<template>
  <main role="main" class="page-content">
    <div class="page-content-overlay" @click="hideNavigation" />

    <breadcrumb />

    <router-view />
  </main>
</template>

<script>
import Breadcrumb from './Breadcrumb.vue';

// @vuese
// Treść strony
// @group AppLayout
export default {
  name: 'Body',
  components: { Breadcrumb },

  methods: {
    // @vuese
    // Chowa menu
    hideNavigation() {
      this.$store.dispatch('setMobileNav', false);
    }
  }
};
</script>
